import React from 'react'
import { IconProps } from '../types'

export default function BriefcaseIcon({
    className = 'h-[14px] w-[20px]',
    fill = 'black',
    fillOpacity = 0.4,
    ...props
}: IconProps & { fillOpacity?: number }) {
    return (
        <svg
            width="20"
            height="14"
            viewBox="0 0 20 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M3.91456 2H0.694557C0.324557 2 -0.0454429 2.32 0.00455707 2.84L1.56456 12.83C1.56456 12.83 3.41456 5.47 3.77456 3.7C3.88456 3.17 4.38456 3 4.75456 3H9.91456C9.91456 3 9.21456 0.92 9.14456 0.69C9.02456 0.25 8.80456 0 8.36456 0H5.05456C4.69456 0 4.35456 0.23 4.25456 0.64C4.16456 1.04 3.91456 2 3.91456 2ZM8.79456 2H4.79456C4.79456 2 5.21456 1 5.66456 1H7.79456C8.27456 1 8.79456 2 8.79456 2ZM2.58456 13.25C2.27456 13.72 1.82456 14 1.32456 14H17.0546C17.5946 14 17.9746 13.69 18.0846 13.17C18.5246 10.98 19.7646 4.73 19.7646 4.73C19.8346 4.23 19.4646 4 19.1446 4H15.9146V2.53C15.9146 2.37 15.6546 2 15.2546 2H11.4946C10.9746 2 10.6246 2.58 10.6246 2.58L9.91456 4H5.50456C5.18456 4 4.87456 4.19 4.81456 4.5C4.81456 4.5 3.22456 11.2 3.09456 11.83C3.02456 12.2 2.87456 12.82 2.58456 13.25ZM15.2946 4H10.9146C10.9146 4 11.4946 3 12.0446 3H14.3346C15.0446 3 15.2946 4 15.2946 4Z"
                fill={fill}
                fillOpacity={fillOpacity}
            />
        </svg>
    )
}
